module.exports = __webpack_public_path__ + "img/1585423284.82a3cfd7.jpg";